/**
 * Tell Unity what's happening
 */
const UNITY_METHOD = {
  loaded: "pageLoaded",
  success: "success",
  back: "back",
};

export { UNITY_METHOD };
